export default __webpack_public_path__ + "static/about-25b77bd07e529c9aa09743bd1d15cd58.webp";